<template>
  <div class="software-page">
    <!-- Banner Section -->
    <section class="banner-section">
      <div class="banner-content">
        <h1 class="banner-title">软件</h1>
      </div>
    </section>

    <!-- Content Section -->
    <section class="content-section">
      <div class="container">
        <!-- Placeholder content -->
        <div class="software-intro">
          <h2>软件介绍</h2>
          <p>这里是软件页面内容。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SoftwarePage'
}
</script>

<style scoped>
.software-page {
  width: 100%;
}

.banner-section {
  width: 100%;
  height: 546px; /* Consistent with other pages */
  background-color: #003296; /* Fallback color */
  background-image: linear-gradient(rgba(0, 50, 150, 0.4), rgba(0, 50, 150, 0.4)); /* Placeholder overlay */
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin: 0;
}

.content-section {
  padding: 80px 0;
  background-color: #fff;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.software-intro h2 {
  font-size: 34px;
  color: #333;
  margin-bottom: 20px;
}

.software-intro p {
  font-size: 16px;
  color: #666;
}
</style>
